<template>
  <div class="editmenu-form">
    <el-dialog
      title="修改菜单"
      :visible="editShow"
      width="35%"
      @close="dialogClose"
    >
      <el-form ref="form" :model="form">
        <el-form-item label="当前菜单">
          <span style="font-weight: bold;">{{ menuInfo.menuName }}</span>
        </el-form-item>
        <el-form-item label="上级菜单" v-if="menuInfo.menuType !== 'M'">
          <!-- <el-select
            v-model="form.parentMenuName"
            placeholder="请选择上级菜单"
            @change="selectParentMenu"
          >
            <el-option
              v-for="item in menuList"
              :key="item.id"
              :label="item.menuName"
              :value="item.id"
            ></el-option>
          </el-select> -->

          <el-cascader
            v-model="form.parentMenuName"
            @change="selectParentMenu"
            placeholder="请选择上级菜单"
            :options="menuData"
            :props="{ checkStrictly: true }"
            clearable
            :show-all-levels="false"
          >
          </el-cascader>
        </el-form-item>
        <!-- <el-form-item label="菜单类型">
          <el-radio-group v-model="form.resource">
            <el-radio label="目录"></el-radio>
            <el-radio label="菜单"></el-radio>
            <el-radio label="按钮"></el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="菜单图标">
          <el-select v-model="form.icon" placeholder="请选择菜单图标">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <!-- <el-form-item label="菜单名称">
          <el-input v-model="form.user" placeholder="请输入菜单名称"></el-input>
        </el-form-item> -->
        <el-form-item label="显示排序">
          <el-input
            v-model.number="form.orderNum"
            placeholder="请输入"
            prop="rank"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- <el-form ref="form" :model="form">
        <el-form-item label="是否外链">
          <el-radio-group v-model="form.externalLinks">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="路由地址">
          <el-input
            v-model="form.router"
            placeholder="请输入路由地址"
            style="width: 220px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示状态">
          <el-radio-group v-model="form.showStatus">
            <el-radio label="显示"></el-radio>
            <el-radio label="隐藏"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单状态">
          <el-radio-group v-model="form.menuStatus">
            <el-radio label="正常"></el-radio>
            <el-radio label="停用"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form> -->
      <div class="btns">
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["editShow", "menuInfo", "menuList"],
  inject: ["refresh"],
  data() {
    return {
      form: {
        parentMenuName: "",
        orderNum: "",
        parentId: "",
      },
      menuData: [{ value: 0, label: "主类目", children: [] }],
    };
  },
  mounted() {
    this.menuData[0].children = this.menuList;
    // console.log("menuList==》", this.menuData);
    this.dialogOpen();
  },
  methods: {
    selectParentMenu(e) {
      this.form.parentId = e;
    },
    dialogClose() {
      this.$emit("update:editShow", false);
    },
    dialogOpen() {
      let menuObj = this.menuList.find(
        (item) => item.id == this.menuInfo.parentId
      );
      this.form.parentMenuName = menuObj ? menuObj.menuName : null;
      this.form.orderNum = this.menuInfo.orderNum;
      this.form.parentId = this.menuInfo.parentId;
    },
    confirm() {
      // console.log(
      //   "修改确认==>",
      //   this.form,
      //   this.menuInfo.id,
      //   this.form.parentId[this.form.parentId.length - 1]
      // );
      this.post(this.$url.updateSchoolMenu, {
        schoolId: this.user.schoolId,
        menuId: this.menuInfo.id,
        parentId: this.form.parentId[this.form.parentId.length - 1],
        orderNum: this.form.orderNum,
      }).then((res) => {
        if (res.code != 200) return this.$message.error(res.msg);
        this.$message.success("修改成功");
        // this.dialogClose();
        // this.refresh();
        this.$router.go(0);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./editMenu.scss";
</style>
